import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
const styles = (theme) => ({
  root: {
    width: "100%",
    // maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

class CheckboxList extends React.Component {
  state = {
    checked: [],
  };

  handleToggle = (value) => () => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  };

  handleToggleAll = (event) => {
    if (event.target.checked) {
      this.setState({ checked: this.props.items.map((n) => n) });
      return;
    }
    this.setState({ checked: [] });
  };

  render() {
    const { classes, items, itemSelected } = this.props;
    return (
      <Card className={classes.list} style={{ height: 400, overflow: "auto" }}>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <Checkbox
              onClick={this.props.handleToggleAll}
              checked={
                this.props.checked.length === items.length && items.length !== 0
              }
              // indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
              disabled={items.length === 0}
            />
          }
          title={this.props.title}
          subheader={`${this.props.checked.length}/${items.length} được chọn`}
        />
        <Divider />
        <List className={classes.root}>
          <Grid container>
            {items.map((value) => {
              const checked =
                this.props.checked.length != 0
                  ? this.props.checked.find((i) => i.id === value.id)
                  : null;
              return (
                <Grid item md={6}>
                  <ListItem
                    key={value}
                    role={undefined}
                    dense
                    button
                    onClick={() => this.props.handleToggle(value)}
                    style={{ width: "100%" }}>
                    <Checkbox
                      checked={checked ? checked.id == value.id : false}
                      tabIndex={-1}
                      disableRipple
                    />
                    <ListItemText
                      primary={`${value.code} - ${value.user.fullname}`}
                      secondary={value.group?.name}
                    />
                  </ListItem>
                </Grid>
              );
            })}
          </Grid>
        </List>
        {/* <IconButton onClick={this.props.handleSelect(this.props.checked)} disabled /> */}
      </Card>
    );
  }
}

CheckboxList.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string,
  itemSelected: PropTypes.array,
};

export default withStyles(styles)(CheckboxList);
